import { BlogPost } from '../blog';

import { ImagePost } from './post';

export default function Post() {
  const image = ImagePost();

  return <BlogPost {...image} />;
}
